<div class="find-waterways page">
  <div class="title mb-30">Find Waterways & Maps by Region</div>
  <div class="content" *ngIf="(regions$ | async).result as regions">
    <div class="item" *ngFor="let region of regions" [routerLink]="stateUrl(region)">{{region.name}}</div>
  </div>
</div>